export const KEY_DRIVER = 'driver';

export const DRIVER_TYPES_MAP = {
    ownerOperatorProvincial: 'Owner Operator',
    ownerOperatorCrossBorder: 'Owner Operator',
    companyDriverProvincial: 'Company Driver',
    companyDriverCrossBorder: 'Company Driver',
    ownerOperatorAcrossCanada: 'Owner Operator',
    companyDriverAcrossCanada: 'Company Driver',
    ownerOperatorCanadaAndUS: 'Owner Operator',
    companyDriverCanadaAndUS: 'Company Driver',
    ownerOperatorIntrastate: 'Owner Operator',
    companyDriverIntrastate: 'Company Driver',
    ownerOperatorAcrossUS: 'Owner Operator',
    companyDriverAcrossUS: 'Company Driver',
    ownerOperatorUSAndCanada: 'Owner Operator',
    companyDriverUSAndCanada: 'Company Driver',
};

export const JURISDICTION_TYPES_MAP = {
    ownerOperatorProvincial: 'Provincial',
    ownerOperatorCrossBorder: 'Cross Border',
    companyDriverProvincial: 'Provincial',
    companyDriverCrossBorder: 'Cross Border',
    ownerOperatorAcrossCanada: 'Across Canada',
    companyDriverAcrossCanada: 'Across Canada',
    ownerOperatorCanadaAndUS: 'Canada And US',
    companyDriverCanadaAndUS: 'Canada And US',
    ownerOperatorIntrastate: 'Intrastate',
    companyDriverIntrastate: 'Intrastate',
    ownerOperatorAcrossUS: 'Across US',
    companyDriverAcrossUS: 'Across US',
    ownerOperatorUSAndCanada: 'US And Canada',
    companyDriverUSAndCanada: 'US And Canada',
};

export const RADIUS_OPTIONS_MAP = {
    provincial: [
        { key: 'provincial', displayName: 'Provincial' }
    ],
    acrossCanada: [
        { key: 'provincial', displayName: 'Provincial' },
        { key: 'acrossCanada', displayName: 'Canada wide' }
    ],
    canadaAndUS: [
        { key: 'provincial', displayName: 'Provincial' },
        { key: 'acrossCanada', displayName: 'Canada wide' },
        { key: 'canadaAndUS', displayName: 'Canada and USA' }
    ],
    intrastate: [
        { key: 'intrastate', displayName: 'Intra State' }
    ],
    acrossUS: [
        { key: 'intrastate', displayName: 'Intra State' },
        { key: 'acrossUS', displayName: 'US wide' }
    ],
    usAndCanada: [
        { key: 'intrastate', displayName: 'Intra State' },
        { key: 'acrossUS', displayName: 'US wide' },
        { key: 'usAndCanada', displayName: 'US and Canada' }
    ]
};

export const HOW_DID_YOU_HEAR_OPTIONS: string[] = [
    'I am an existing employee of this company',
    'Company Website',
    'Job board - Indeed, LinkedIn etc.',
    'Social Media Ad / Post',
    'Referral from a Current Driver',
    'Referral from a Friend or Family Member',
    'Job Fair or Hiring Event',
    'Recruiting Agency / Truck Driver Recruiter',
    'Trucking School / CDL Training Institute',
    'Highway Billboard / Truck Stop Flyer',
    'WhatsApp / Telegram Group',
    'Magazine / Newspaper',
    'Other (please specify)'
];

export const OPTIONS_REQUIRING_DETAILS: string[] = [
    'Referral from a Current Driver',
    'Referral from a Friend or Family Member',
    'Job Fair or Hiring Event',
    'Recruiting Agency / Truck Driver Recruiter',
    'Trucking School / CDL Training Institute',
    'WhatsApp / Telegram Group',
    'Magazine / Newspaper',
    'Other (please specify)',
    'I am an existing employee of this company',
];

export const POSITION_OPTIONS = [
    { key: 'companyDriver', displayName: 'Company Driver' },
    { key: 'ownerOperator', displayName: 'Owner Operator' }
];
